
import commonFetch from './commonFetch';

type SendFeedbackBody = {
  subject: string,
  message: string,
  userAgent: string,
  submitted: string,
  context: string,
};

export const feedbackUrl = '/feedback';
//also exporting this as it's the namesake of the file, but other files don't use default exports, so either import style should work for this
export const sendFeedback = (body: SendFeedbackBody) => {
  return commonFetch(feedbackUrl, body, 'POST');
};

export default sendFeedback;
